/**
 * 라운지 맞물림 — 전환 전까지만(DOC-141 §13).
 *
 * 화면은 안전 서버(safe-back)의 이름으로 짜여 있다. 운영 safe 는 전환일까지 라운지 서버를 보므로, 그동안은 라운지와 이름이
 * 다른 세 값을 여기서 바꿔 읽고 쓴다. 경로(/api/v1/safe → /api/v1/safety)는 safe nginx 가 바꾼다(nginx.conf.template).
 *
 *  - 권한 키 · 순찰 갈래 값 · 일지 줄 수 키 — 라운지 DB 와 라운지 코드가 정한 이름이라 라운지 쪽에서 못 바꾼다.
 *
 * 어느 서버인지는 nginx 가 `/backend-kind` 로 알려 준다(BACKEND_ORIGIN 이 bomi-back 이면 lounge). 전환일에 BACKEND_ORIGIN 만
 * 바꾸면 저절로 꺼진다. 7단계(라운지 쪽 걷기)에 이 파일째 지우고, 부르는 세 곳(main · access · api/client)을 함께 걷는다.
 */

/** 라운지가 쓰는 이름. 안전 서버에서는 각각 'safe' · 'SAFE' · 'safe' 다. */
const LOUNGE_MENU_KEY = 'safety';
const LOUNGE_PATROL_KIND = 'SAFETY';
const LOUNGE_ROW_KEY = 'safety';

let onLounge = false;

/** 화면을 그리기 전에 한 번. 개발 서버처럼 `/backend-kind` 가 없으면(글자가 lounge 가 아니면) 안전 서버로 본다. */
export async function detectBackend(): Promise<void> {
  try {
    const response = await fetch('/backend-kind', { cache: 'no-store' });
    onLounge = response.ok && (await response.text()).trim() === 'lounge';
  } catch {
    onLounge = false;
  }
}

/** 「안전 전체 권한」 메뉴 키. */
export function safeMenuKey(): string {
  return onLounge ? LOUNGE_MENU_KEY : 'safe';
}

type Direction = 'in' | 'out';

/** 라운지에서 받은 답(in) · 라운지로 보낼 본문(out)의 이름을 바꾼다. 안전 서버면 그대로 돌려준다. */
export function mapForLounge<T>(value: T, direction: Direction): T {
  return onLounge ? (walk(value, direction) as T) : value;
}

function walk(value: unknown, direction: Direction): unknown {
  if (Array.isArray(value)) return value.map((item) => walk(item, direction));
  if (value === null || typeof value !== 'object') return value;
  const out: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
    if (key === 'patrolKind' && typeof child === 'string') {
      out[key] = direction === 'in' ? (child === LOUNGE_PATROL_KIND ? 'SAFE' : child) : child === 'SAFE' ? LOUNGE_PATROL_KIND : child;
    } else if (key === 'rowLayout' && child !== null && typeof child === 'object' && !Array.isArray(child)) {
      const from = direction === 'in' ? LOUNGE_ROW_KEY : 'safe';
      const to = direction === 'in' ? 'safe' : LOUNGE_ROW_KEY;
      out[key] = Object.fromEntries(Object.entries(child as Record<string, unknown>).map(([k, v]) => [k === from ? to : k, v]));
    } else {
      out[key] = walk(child, direction);
    }
  }
  return out;
}
